// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__34N0U","footer":"styles_footer__2qMHs"};